import type { NavigationGuardWithThis } from 'vue-router';
import { authenticatedSettingsLoadPromise } from '../composables/use-settings-load-when-authenticated';
import { defaultSettings } from '../composables/use-settings';
import { settingsLoadPromise } from '../composables/use-update-settings';
import { useHAlerts } from '../composables/use-alerts';
import { useHTranslate } from '../composables/use-translate';
import {
  ADMIN_RESOURCES_DISABLED_KEY,
  ADMIN_RESOURCES_SETTING_KEY,
  isAdminResourcesEnabled,
  isAdminResourcesRoute,
} from '../utils/admin-resources';

export const ADMIN_RESOURCES_DISABLED_ALERT_ID = 'admin-resources-disabled';

function notifyAdminResourcesDisabled() {
  const { hAddAlert } = useHAlerts();

  hAddAlert({
    id: ADMIN_RESOURCES_DISABLED_ALERT_ID,
    type: 'warning',
    title: useHTranslate(ADMIN_RESOURCES_DISABLED_KEY),
    closable: true,
    timeout: 8_000,
  });
}

/**
 * Hides the admin resources page when `admin_resources_enabled` is false.
 * Settings remain available so an admin can turn the flag back on.
 */
export const adminResourcesGuard: NavigationGuardWithThis<undefined> = async (to) => {
  if (!isAdminResourcesRoute(to)) {
    return;
  }

  await settingsLoadPromise;
  await authenticatedSettingsLoadPromise;

  if (isAdminResourcesEnabled(defaultSettings[ADMIN_RESOURCES_SETTING_KEY])) {
    return;
  }

  notifyAdminResourcesDisabled();
  return { path: '/admin/dashboard' };
};
